import styled from '@emotion/styled';
import { Swiper } from 'swiper/react';

import Card from 'components/global/Card';

import { Breakpoints } from 'utils/const.styles';

export const SwiperContainer = styled(Swiper)`
	.swiper-wrapper {
		padding-bottom: 4rem;
	}
`;

export const Header = styled.div`
	display: grid;
	grid-template-columns: max-content 3rem;
	align-items: center;
	gap: 0.5rem;
`;

export const StyledDataCard = styled(Card)`
	cursor: pointer;
	border: 1px solid var(--border-color);
	padding: var(--padding-4) var(--padding-2);
	background-color: var(--white);
	border-radius: var(--small-border-radius);
	display: grid;
	grid-template-columns: 5rem auto;
	gap: var(--margin-4);
	align-items: center;
	margin: 0 0.5rem;
`;

export const TextWrapper = styled.div`
	min-height: 7rem;
	display: flex;
	flex-direction: column;
	justify-content: center;

	@media ${Breakpoints.tablet} {
		min-height: 9rem;
	}
`;
